export const SPINNER_SHOW = 'SPINNER_SHOW';
export const SPINNER_HIDE = 'SPINNER_HIDE';
export const SPINNER_ACTIVATION = 'SPINNER_ACTIVATION';
export const SPINNER_PROGRESS = 'SPINNER_PROGRESS';
export function showSpinner() {
    return {
        type: SPINNER_SHOW,
    };
}
export function hideSpinner() {
    return {
        type: SPINNER_HIDE,
    };
}
export function isCommunicatingWithServer(active) {
    return {
        type: SPINNER_ACTIVATION,
        active,
    };
}
export function changeProgress(progress) {
    return {
        type: SPINNER_PROGRESS,
        progress,
    };
}
